/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input} from '@angular/core';
import {SubscriptionTypeVoModel} from "@well/domain";
import {SharedComponentsModule} from "@well/shared-components";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'well-subscription-card-view',
  templateUrl: './subscription-card-view.component.html',
  styleUrls: ['./subscription-card-view.component.scss'],
  imports: [CommonModule,
            SharedComponentsModule,
            TranslateModule

  ],
  standalone: true
})
export class SubscriptionCardViewComponent {

  @Input() subscription : SubscriptionTypeVoModel | undefined = undefined;

  privateVisibility = 'private';
}
